






































































































import Vue from "vue";
import ApiService from "@/services/ApiService";
import SingleCouncil from "@/modals/SingleCouncil.vue";
import SingleSchool from "@/modals/SingleSchool.vue";
import TravelFeatures from "./school/TravelFeatures.vue";
export default Vue.extend({
  data() {
    return {
      councils: [],
      loading: true,
      showMainModal: false,
      queryParamsForTD: "",
      title: "",
    };
  },
  components: {
    TravelFeatures,
  },
  methods: {
    handleClick() {
      alert("test");
    },
    newCouncil() {
      this.$router.push({
        name: "Edit Organization",
        params: { org_id: "new" },
      });
    },
    openCouncil(id) {
      this.$modal.show(
        SingleCouncil,
        {
          options: {
            profilePicture: true,
          },
          id,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: "auto",
          adaptive: true,
          // pivotY: 0
        },
        {}
      );
    },
    openSchool(id) {
      this.$modal.show(
        SingleSchool,
        {
          options: {
            profilePicture: true,
          },
          id,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: "auto",
          adaptive: true,
          // pivotY: 0
        },
        {}
      );
    },
    openSchfool(id) {
      alert(id);
    },
    openTravelDirectory(id, title) {
      this.queryParamsForTD = "type=council&type_id=" + id;
      this.title = title;
      this.showMainModal = true;
      // this.$router.push("/members/travel_features/school/" + id);
    },
    closeMainModal() {
      this.showMainModal = false;
    },
  },
  mounted() {
    ApiService.generalApi.getCouncils().then((response) => {
      const councils = response.data.data;
      councils.forEach((element) => {
        // if (element.schools) {
        //   element.children = element.schools;
        // }
      });
      this.councils = councils;
      this.loading = false;
    });
  },
});
